import React, { Component } from 'react';
import { connect } from "react-redux";
import { getFormValues } from "redux-form";
import { Row, Col, Card, CardHeader, Container } from "reactstrap";
import VmProviderConfigForm from "../VmProviderConfigForm/VmProviderConfigForm";
import { createVmProviderConfig } from '../../../actions/actionVmProvider';
import { handleSaveSuccess, handleSaveError } from '../actions'


class CreateVmProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
        this.submitApi = this.submitApi.bind(this);
        this.handleSaveError = handleSaveError.bind(this);
        this.handleSaveSuccess = handleSaveSuccess.bind(this);

    }

    componentDidMount(){
        this.props.getVmProviderConfigs();
    }

    async submitApi() {
        try {
            await this.props.createVmProviderConfig(this.props.providerValues)
            const provider = await this.handleSaveSuccess()
            this.props.savedProvider(provider)
        } catch (e) {
            this.handleSaveError()
        }
    }

    render() {
        return (
            <div >
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className="user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create VM Provider Config</strong>
                                </CardHeader>
                                <VmProviderConfigForm
                                    onSubmit={this.submitApi}
                                    createVmProviderConfig={this.props.createVmProviderConfig} />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

export default connect(state =>
({
    vm_provider_configs: state.vm_provider.vm_provider_configs || [],
    saveVmProviderError: state.vm_provider.saveVmProviderError,
    saveVmProviderLoading: state.vm_provider.saveVmProviderLoading,
    savedVmProvider: state.vm_provider.savedVmProvider,
    providerValues: getFormValues('VmProviderForm')(state),
}),
    dispatch =>
    ({
        createVmProviderConfig: (data) => dispatch(createVmProviderConfig(data))
    }))(CreateVmProviderConfig);
